export default "__VITE_ASSET__CJlLQF18__"